module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daylightsnow-fd99deddbb1f7e10ad418b5919a0e6b5.png";